// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"75":"61e34268","80":"3ea1342d","571":"c32ec5f5","646":"4482f54f"}[chunkId] + ".chunk.js";
};